<template>
  <div id="app">
    <!-- banner-body -->
    <div class="banner-body">
        <div class="container">
        <!-- header -->
        <rwv-header></rwv-header>
        <div class="clearfix"> </div>
        <!-- //header -->
        <router-view></router-view>
      </div>
    </div>
    <rwv-footer></rwv-footer>
    <div class="footer-bottom">
        <div class="container">
            <p>© 2015 Quickly. All rights reserved | Design by <a href="http://w3layouts.com/"> W3layouts</a></p>
        </div>
        <div>
            <div role="presentation">
            </div>
            <a class="accreditation" href="https://www.a2hosting.com/drupal-hosting?aid=funktechno&amp;bid=d61953ed" target="_blank" rel="nofollow" tabindex="-1"><img src="//lh3.googleusercontent.com/proxy/5ED1YUGjFC93154wpBVO4oG6CICKCPA5bASGtPd0MlxuALu5QzSmA5KKO2dU6CZ4RWiLrIDgsc9uHTvpUOBFFIiatheH3C0MmmsHCOGu0jYTkA14DRY=s80-p-k-rw" width="80" height="80" alt=""></a>
        </div>
        <div role="presentation">
            <div><a class="accreditation" href="https://www.a2hosting.com/drupal-hosting?aid=funktechno&amp;bid=d61953ed" target="_blank" rel="nofollow" tabindex="-1"><span class="aaTEdf">Drupal Web Hosting | 20X Faster Drupal Hosting</span></a></div>
            <div><a class="accreditation" href="https://www.a2hosting.com/drupal-hosting?aid=funktechno&amp;bid=d61953ed" target="_blank" rel="nofollow" tabindex="-1">a2hosting.com</a></div>
            <div>Drupal Recommended Hosting! Sign Up Today &amp; Get The Fastest Drupal Web Hosting On Market Hosted on High Performance Turbo Servers!</div>
        </div>
    </div>
  </div>
</template>

<script>
import RwvHeader from '@/components/TheHeader'
import RwvFooter from '@/components/TheFooter'
// styling
import '../css'

// <!-- fonts -->
import '../fonts/font-awesome-4.7.0/css/font-awesome.min.css'

import '../dependencies'

export default {
  name: 'App',
  components: {
    RwvHeader,
    RwvFooter
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue